import { Box, Grid, Typography, Divider, Stack } from "@mui/material";
import LinearWithValueLabel from "../linearProgressBar";
import React, { useState, useEffect } from "react";


const ManageConnectionHeader = (props) => {


    useEffect(() => {
        document.title = "Arpari | " + (props.title || "Manage Connections")
    }, [props.title]);
    

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                {/* Left Section */}
                <Grid item xs={8}>
                    <Box
                        sx={{
                            margin: (theme) => theme.spacing(0),
                            backgroundColor: "white",
                            border: (theme) => `1px solid ${theme.palette.secondary.light}`,
                            borderRadius: 1,
                            padding: (theme) => theme.spacing(1),
                            minHeight: "100px",
                            width: "100%",
                            height: "100%"
                        }}
                    >
                        <Typography variant="overline" fontSize={12}>{props.title}</Typography>
                        <Divider />
                        {/* Connection Health Progress Bar */}
                        <Grid container>
                            <Grid item xs={12}>
                                <Stack direciton="column">
                                    <Typography variant="overline" fontSize={11}>
                                        {`Connection Health - ${props.totalHealthy} / ${props.total}`} {props.connectionHealthSuffix}
                                    </Typography>
                                    <LinearWithValueLabel
                                        numerator={props.totalHealthy}
                                        denominator={props.total}
                                        show100={true} />

                                    {props.titleBoxExtra}
                                </Stack>
                            </Grid>
                        </Grid>


                    </Box>
                </Grid>

                {/* Right Section */}
                <Grid item xs={4}>
                    <Box sx={{
                        margin: (theme) => theme.spacing(0),
                        minHeight: "100px",
                        width: "100%",
                        height: "100%",
                    }}>
                        <Grid
                            container
                            direction="column"
                            rowGap={2}
                            sx={{ width: "100%", justifyContent: "center", alignItems: "center" }}
                        >
                            {/* action buttons */}
                            <Grid item xs={12} sx={{ width: "100%" }}>
                                <Box sx={{
                                    width: '100%', border: (theme) => `1px solid ${theme.palette.secondary.light}`, borderRadius: 1, backgroundColor: "white",
                                    margin: (theme) => theme.spacing(0),
                                    padding: '2rem'
                                }}>
                                    {props.actions}
                                </Box>
                            </Grid>

                            {/* Stats Section */}
                            <Grid item xs={12} sx={{ width: "100%" }}>
                                <Box
                                    sx={{
                                        margin: 0,
                                        backgroundColor: "white",
                                        border: (theme) => `1px solid ${theme.palette.secondary.light}`,
                                        borderRadius: 1,
                                        padding: 1,
                                        minHeight: "100px",
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        divider={<Divider orientation="vertical" flexItem />}
                                        sx={{ justifyContent: "space-evenly", alignItems: "stretch" }}
                                        spacing={2}
                                    >
                                        <Stack direction="column" sx={{ alignItems: "center", justifyContent: "space-around" }}>
                                            <Typography variant="h1" color="primary">{props.stat1}</Typography>
                                            <Typography color="secondary">{props.stat1Title}</Typography>
                                        </Stack>
                                        <Stack direction="column" sx={{ alignItems: "center", justifyContent: "space-around" }}>
                                            <Typography variant="h1" color="primary">{props.stat2}</Typography>
                                            <Typography color="secondary">{props.stat2Title}</Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ManageConnectionHeader;
